import React from 'react';
import { appSessionStorage } from '../utils/storage';
import { getLanguage } from '../utils/func';
import message from '../components/Brand/brandMessage';
import { deletionReviewCopy } from './copy';

export const loginPurpose = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('deletion_status') === '1' ? 'deletion_status' : params.get('register_new') === '1' ? 'register_new' : 'sign_in';
};
export function notifyDeletedLogin(code, language) {
  if (code === 'ACCOUNT_DELETION_NEEDS_REVIEW') {
    // Only a verified legacy login can reach this state. It is not an active
    // deletion request and must not offer restoration or a new-account bypass.
    message.warning({ content: <>{deletionReviewCopy(language || getLanguage())}<br />
      <a href="mailto:rpk@wiw.today">rpk@wiw.today</a></>, duration: 10 });
    return true;
  }
  if (['ACCOUNT_DELETED', 'AUTH_ATTEMPT_PRECEDES_DELETION'].includes(code)) {
    try { appSessionStorage.setItem(deletedLoginNoticeKey, '1'); } catch { /* current document still receives event */ }
    window.dispatchEvent(new Event('wiw:account-login-deleted'));
  }
  return false;
}
export const deletedLoginNoticeKey = 'account-deletion:login-notice';
